export default __webpack_public_path__ + "static/guts-39e2587f6db7e4c1d631b0d394b0117f.mp4";